export default __webpack_public_path__ + "static/media/header_sp.a7e8fc10.png";